import React from 'react'
import classNames from 'classnames'

const Spinner = props => {
  const { title, transparent, noMargin, ...restProps } = props
  return (
    <span
      className={classNames({
        spinner: true,
        'spinner--transparent': transparent,
        'spinner--no-margin': noMargin,
      })}
      {...restProps}
    >
      {title && <span className="spinner__title">{title}</span>}
      <span className="spinner__circles">
        <span className="spinner__circle" />
        <span className="spinner__circle" />
        <span className="spinner__circle" />
      </span>
    </span>
  )
}

Spinner.displayName = 'Spinner'

export default Spinner
